export default __webpack_public_path__ + "static/media/hht1_ep02_timeline_q03_05_a.cf1b843a.png";